import { Box } from 'components/Box';
import Footer from 'components/Footer/Footer.component';
import { useStore } from 'react-redux';
import { selectSessionInfo } from 'services/session/session.selectors';
import { AppChannel } from 'utils/config.config';
import { useShowFooterOnAppSeu } from './PageScaffolding.hooks';
import { PageScaffoldingProps } from './PageScaffolding.types';
import { Page, PageContent } from './style/PageScaffolding.style';

export default function PageScaffolding({
  children,
  footer,
  className,
  footerCtaTrackingClick,
}: PageScaffoldingProps) {
  const reduxStore = useStore();
  const showFooterOnAppSeu = useShowFooterOnAppSeu();
  const { channel } = selectSessionInfo(reduxStore.getState());
  const showFooter =
    channel === AppChannel.PortaleWebFullResponsiveWwwSisalIt ||
    channel === AppChannel.ClientDesktopSisalPoker;
  return (
    <Page className={className}>
      <PageContent channel={channel}>{children}</PageContent>
      {showFooterOnAppSeu && (
        <Box paddingBottom="72px">
          <Footer footerCtaTrackingClick={footerCtaTrackingClick} />
        </Box>
      )}
      {showFooter &&
        (footer ?? <Footer footerCtaTrackingClick={footerCtaTrackingClick} />)}
    </Page>
  );
}
